import React from 'react';
import { components } from 'react-select';
import { FormattedMessage } from 'i18n';

function Option(props) {
  return (
    <components.Option {...props}>
      <FormattedMessage {...props.data.label} />
    </components.Option>
  );
}

export default Option;
